export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14952.8180ccb1.jpg";